<template>
	<v-app-bar
		app
		elevate-on-scroll
		color="backgroundOryx"
		style="border-bottom: 1px solid #cfcfca !important; z-index: 10"
	>
		<v-app-bar-nav-icon
			@click="parameters.openLeftMenu = !parameters.openLeftMenu"
		></v-app-bar-nav-icon>
		<v-spacer></v-spacer>
		<a @click="$router.push('/oryxpdv')" class="text-grey text--darken-1">
			<v-toolbar-title
				class="font-weight-bold title"
				style="font-family: Muli !important"
				>{{ title }}</v-toolbar-title
			>
		</a>
		<v-spacer></v-spacer>
		<v-menu offset-y :nudge-width="130">
			<template v-slot:activator="{ on, attrs }">
				<v-btn icon v-bind="attrs" v-on="on">
					<v-icon>mdi-dots-vertical</v-icon>
				</v-btn>
			</template>
			<v-list>
				<v-list-item @click="logoff()">
					<v-list-item-icon>
						<v-icon>mdi-logout</v-icon>
					</v-list-item-icon>
					<v-list-item-title>Sair</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
	</v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	data: () => ({}),
	computed: {
		parameters: {
			get() {
				return this.$store.state.parameters;
			},
		},
		...mapGetters({
			getDc0nome: "parameters/getDc0nome",
		}),
		title() {
			if (this.$route.meta.title) return this.$route.meta.title;
			if (this.getDc0nome) return this.getDc0nome;

			return "ORYX PDV";
		},
	},
    methods:{
        logoff(){
            this.$store.dispatch("dc4/logoff");
        }
    }
};
</script>

<style></style>
